<script lang="ts">
    import moment from "moment";

    import { onMount } from "svelte";
    import { APIHelper } from "../code/APIHelper";
    import DBG from "../code/DBG";
    import Intercoms from "../code/Intercoms";
    import ProjectData from "../code/ProjectData";
    import type ProjSettings from "../code/model/ProjSettings";
    import GlobalSettings from "../code/GlobalSettings";
    import Button from "./Generic/Button.svelte";

    export let projSetting: ProjSettings;

    let dateSamples = [
        { id: "ddd DD/MM/YYYY", text: `Wed 10/12/2021` },
        { id: "DD/MM/YYYY", text: `10/12/2021` },
        { id: "DD/MM/YYYY hh:mm", text: `10/12/2021 10:20` },
    ];
    let dateFormats = [];
    let buttonLabel = "DONE";
    let textFields = [
        { id: "Text10", text: `Text10` },
        { id: "Text11", text: `Text11` },
        { id: "Text12", text: `Text12` },
        { id: "Text13", text: `Text13` },
        { id: "Text14", text: `Text14` },
        { id: "Text15", text: `Text15` },
    ];

    onMount(() => {
        DBG.log(
            "Settings - onMount",
            Office.ProjectTaskFields.Start,
            projSetting
        );
        buttonLabel = "DONE";
        let dateNow = new Date();
        dateSamples.forEach((el) => {
            dateFormats.push({
                id: el.id,
                text: moment(dateNow).format(el.id),
            });
        });
        dateFormats = dateFormats;
    });

    function saveSettingsAndClose() {
        buttonLabel = "Saving...";
        GlobalSettings.settings = projSetting;
        APIHelper.SetProjectSettings(projSetting);
        Intercoms.send("settings.closed");
    }
    function saveSettings() {
        buttonLabel = "Saving...";
        APIHelper.SetProjectSettings(projSetting).then((str) => {
            DBG.log("Settings - saveSettings result:", str);
        });
    }
    function testAPI() {
        APIHelper.callAPI("getStorage", "test-storage").then((res) => {
            DBG.log("Settings - test API", res);
        });
    }
    function logOut() {
        DBG.log("Settings - logOut");
        //openDialog();
        APIHelper.logOut().then(() => {
            DBG.log("Settings - logOut DONE");
            setTimeout(() => {
                window.location.href = "/";
            }, 200);
        });
    }
    function openDialog() {
        DBG.log("Settings - openDialog, windows location", window.location);
        Office.context.ui.displayDialogAsync(
            window.location.origin + "/signout",
            (result) => {
                DBG.log("Settings - display dialog result:", result);
                result.value.addEventHandler(
                    Office.EventType.DialogMessageReceived,
                    (args) => {
                        DBG.log("Settings - DialogMessageReceived:", args);
                        result.value.close();
                        window.location.reload();
                    }
                );
                result.value.addEventHandler(
                    Office.EventType.DialogEventReceived,
                    (args) => {
                        DBG.log("Settings - DialogEventReceived:", args);
                        result.value.close();
                    }
                );
                result.value.addEventHandler(
                    Office.EventType.DialogParentMessageReceived,
                    (args) => {
                        DBG.log(
                            "Settings - DialogParentMessageReceived:",
                            args
                        );
                        result.value.close();
                    }
                );
            }
        );
    }
</script>

<div id="settings">
    <h1>Settings <i class="fa fa-cogs" /></h1>

    {#if projSetting}
        <div class="setting">
            Project id: {projSetting.projectGuid}
        </div>
        <div class="setting">
            <span>Project name</span>
            <input bind:value={projSetting.projectName} />
        </div>

        <div class="setting">
            <span>Date format</span>
            <select
                bind:value={projSetting.dateFormat}
                on:change={() => {
                    DBG.log("Settings - Date format changed");
                }}
            >
                {#each dateFormats as df}
                    <option value={df.id}>
                        {df.text}
                    </option>
                {/each}
            </select>
        </div>
        <div class="setting">
            <span>Use horizontal scrolling</span>
            <input type="checkbox" bind:checked={projSetting.wideChart} />
        </div>
        <div class="setting">
            <span>Show chart legend</span>
            <input type="checkbox" bind:checked={projSetting.showChartLegend} />
        </div>
        <div class="setting">
            <span>Field for <strong>Sector start</strong></span>
            <select bind:value={projSetting.sectorStart}>
                {#each GlobalSettings.numericFields as nf}
                    <option value={nf.id}>
                        {nf.text}
                    </option>
                {/each}
            </select>
        </div>
        <div class="setting">
            <span>Field for <strong>Sector end</strong></span>
            <select bind:value={projSetting.sectorEnd}>
                {#each GlobalSettings.numericFields as nf}
                    <option value={nf.id}>
                        {nf.text}
                    </option>
                {/each}
            </select>
        </div>
    {/if}
    <!--<button on:click={testAPI}>API</button>-->
    <div class="settings-controls">
        <div class="col-6 col-md-3">
            <Button
                Text={buttonLabel}
                Icon="fa-save"
                on:click={saveSettingsAndClose}
            />
        </div>
        <div class="col-6 col-md-3">
            <Button
                Text="Log out"
                Icon="fas fa-sign-out-alt"
                on:click={logOut}
            />
        </div>
    </div>

    <p class="small">
        Licenced to: {ProjectData.authUser.Name}, {ProjectData.authUser
            .Company}. Licence: {ProjectData.authUser.LicenceType}, expires in: {ProjectData.authUser.daysTillExpiry()}
        days.
    </p>
    <!--  <a href="/.auth/logout">Log out</a>-->
</div>

<style>
    #settings {
        display: flex;
        flex-direction: column;
    }
    .setting {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
        border-bottom: 1px solid gainsboro;
        margin-bottom: 1rem;
    }
    .setting:first-child {
        margin-right: 1rem;
    }

    .settings-controls {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
</style>
